import { render, staticRenderFns } from "./BotonCancelar.vue?vue&type=template&id=66cc9488&scoped=true"
import script from "./BotonCancelar.vue?vue&type=script&lang=js"
export * from "./BotonCancelar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc9488",
  null
  
)

export default component.exports